/// <amd-module name="redux/Actions/MetaTypes" />
/**
 * Used to indicate an action that is required for TTI
 */
export const enum MetaTypes {
    ERROR_TELEMETRY_PROPS = "ERROR_TELEMETRY_PROPS",
    TELEMETRY_PROPS = "TELEMETRY_PROPS",
    TTI_ACTION = "TTI_ACTION"
}
